import tr from "./tr.json";
import en from "./en.json";
import az from "./az.json";

export const languageList = { tr, en, az };

export const LanguageConfig = {
    isSelectable: false,
    options: [
        {
            label: "Türkçe",
            value: "tr"
        },
        {
            label: "İngilizce",
            value: "en"
        },
        {
            label: "Azerice",
            value: "az"
        }
    ]
};
